'use client';

import { c as _c } from "react/compiler-runtime";
import 'swiper/css';
import 'swiper/css/effect-creative';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Modal, Plus } from '@components/modal-window/Modal';
import ParallaxMedia from '@components/parallax-media/ParallaxMedia';
import Big from '@images/renders/infrastructure_images/Infra_Desktop_Webp/14.webp';
import Medium from '@images/renders/infrastructure_images/Infra_Desktop_Webp/15.webp';
import Small from '@images/renders/infrastructure_images/Infra_Desktop_Webp/16.webp';
import Big_Mob from '@images/renders/infrastructure_images/Infra_Mobile_Webp/14.webp';
import Medium_Mob from '@images/renders/infrastructure_images/Infra_Mobile_Webp/15.webp';
import Small_Mob from '@images/renders/infrastructure_images/Infra_Mobile_Webp/16.webp';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import style from './SeventhScreenInfra.module.scss';
function SeventhScreenGeneralMobile() {
  const $ = _c(20);
  const [isModal, setModal] = React.useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setModal(false);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onClose = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setModal(true);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isOpen = t1;
  let t2;
  let t3;
  if ($[2] !== isModal) {
    t2 = () => {
      if (isModal) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "unset";
      }
    };
    t3 = [isModal];
    $[2] = isModal;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div data-scroll={true} data-scroll-speed="0.5" className={style.fourthScreenTitle}>Инфраструктура{t4} считанных шагов<br /></div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={style.fourthScreenWrapper}><div className={style.fourthScreenTextBox}>{t5}<div data-scroll={true} data-scroll-speed="0.5" className={style.fourthScreenDescription}><p>Побаловать внутреннего кофемана во время прогулки, вкусно перекусить или поужинать всей семьёй вне дома можно не покидая Моментс.</p></div></div></div>;
    t7 = <ParallaxMedia className={style.seventhScreenBg} src={Big} src375={Big_Mob} alt="image" imagePlug={Big} />;
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  const t8 = isModal ? style.plusNonActive : style.plusActive;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Plus isOpen={isOpen} />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t8) {
    t10 = <div className={t8}>{t9}</div>;
    $[10] = t8;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== isModal) {
    t11 = <Modal visible={isModal} content={Big_Mob} onClose={onClose} width={typeof window !== "undefined" ? window.screen.width : 0} />;
    $[12] = isModal;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div><ParallaxMedia src={Medium} src375={Medium_Mob} alt="image" className={style.thirdScreenLowContainerMediumImg} imagePlug={Medium} /></div>;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div data-scroll={true} data-scroll-speed="0.5" className={classNames(style.fourthScreenDescription, style.fourthScreenDescription_second)}><p>Кофейни, пекарни, рестораны и семейные кафе расположены вдоль прогулочных зон. Решение насущных вопросов тоже не будет отнимать много времени.</p><p>Супермаркет, гастрономические лавки, винотека, салоны красоты, ателье, химчистка, аптека и прочие полезные сервисы расположены на первых этажах.</p></div>;
    t14 = <ParallaxMedia src={Small} src375={Small_Mob} alt="image" className={style.thirdScreenLowContainerSmallImg} imagePlug={Small} />;
    $[15] = t13;
    $[16] = t14;
  } else {
    t13 = $[15];
    t14 = $[16];
  }
  let t15;
  if ($[17] !== t10 || $[18] !== t11) {
    t15 = <div data-scroll={true} className={style.thirdScreenContainer} id="seven">{t6}{t7}{t10}{t11}{t12}{t13}{t14}</div>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  return t15;
}
export default SeventhScreenGeneralMobile;